/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GetAdminOverviewKpiResponse { 
    /**
     * Total user profiles, excluding soft-deleted accounts.
     */
    totalUsers: number;
    /**
     * Activities whose start date is in the future.
     */
    totalUpcomingActivities: number;
    /**
     * Activities whose start date has passed.
     */
    totalPastActivities: number;
    /**
     * Total groups, excluding soft-deleted ones.
     */
    totalGroups: number;
}

